import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  addNodeFailed,
  addNodeSuccess,
  addPropertyFailed,
  addPropertySuccess,
  deleteNodeFailed,
  deleteNodeSuccess,
  editNodeFailed,
  editNodeSuccess,
  getChildNodesFailed,
  getChildNodesSuccess,
  getNodePropertiesFailed,
  getNodePropertiesSuccess,
  getRootNodesFailed,
  getRootNodesSuccess
} from '../actions/data-explorer/Actions';
import {
  AddNode,
  AddProperty,
  DeleteNode,
  EditNode,
  GetChildNodes,
  GetNodeProperties
} from '../actions/data-explorer/ActionTypes';
import {
  addNode,
  addProperty,
  deleteNode,
  editNode,
  getChildNodes,
  getResourceProperties,
  getRootNodes
} from '../api/DataExplorer';
import * as Constants from '../constants';

function* getRootNodesSaga() {
  try {
    const rootNodes = yield call(getRootNodes);
    yield put(getRootNodesSuccess(rootNodes));
  } catch (error) {
    yield put(getRootNodesFailed());
  }
}

function* watchForGetRootNodes() {
  yield takeLatest(Constants.GET_ROOT_NODES, getRootNodesSaga);
}

function* getChildNodesSaga(action: GetChildNodes) {
  try {
    const parentVmid = action.payload.vmid;
    const childNodes = yield call(getChildNodes, parentVmid);
    yield put(getChildNodesSuccess(parentVmid, childNodes));
  } catch (error) {
    yield put(getChildNodesFailed());
  }
}

function* watchForGetChildNodes() {
  yield takeLatest(Constants.GET_CHILD_NODES, getChildNodesSaga);
}

function* addNodeSaga(action: AddNode) {
  try {
    const addedNode = yield call(addNode, action.payload.node);
    yield put(addNodeSuccess(addedNode));
  } catch (error) {
    yield put(addNodeFailed());
  }
}

function* watchForAddNode() {
  yield takeLatest(Constants.ADD_NODE, addNodeSaga);
}

function* editNodeSaga(action: EditNode) {
  try {
    const editedNode = yield call(editNode, action.payload.node);
    yield put(editNodeSuccess(editedNode));
  } catch (error) {
    yield put(editNodeFailed());
  }
}

function* watchForEditNode() {
  yield takeLatest(Constants.EDIT_NODE, editNodeSaga);
}

function* deleteNodeSaga(action: DeleteNode) {
  try {
    yield call(deleteNode, action.payload.vmid);
    yield put(deleteNodeSuccess(action.payload.vmid));
  } catch (error) {
    yield put(deleteNodeFailed());
  }
}

function* watchForDeleteNode() {
  yield takeLatest(Constants.DELETE_NODE, deleteNodeSaga);
}

function* getNodePropertiesSaga(action: GetNodeProperties) {
  try {
    const properties = yield call(getResourceProperties, action.payload.vmid);
    yield put(getNodePropertiesSuccess(properties));
  } catch (error) {
    yield put(getNodePropertiesFailed());
  }
}

function* watchForGetNodeProperties() {
  yield takeLatest(Constants.GET_NODE_PROPERTIES, getNodePropertiesSaga);
}

function* addPropertySaga(action: AddProperty) {
  try {
    const addedProperty = yield call(addProperty, action.payload.property);
    yield put(addPropertySuccess(addedProperty));
  } catch (error) {
    yield put(addPropertyFailed());
  }
}

function* watchForAddProperty() {
  yield takeLatest(Constants.ADD_PROPERTY, addPropertySaga);
}

export default function* dataExplorerSaga() {
  yield all([
    watchForGetRootNodes(),
    watchForGetChildNodes(),
    watchForAddNode(),
    watchForEditNode(),
    watchForDeleteNode(),
    watchForGetNodeProperties(),
    watchForAddProperty()
  ]);
}
